import { render, staticRenderFns } from "./clientReject.vue?vue&type=template&id=15d66501&scoped=true"
import script from "./clientReject.vue?vue&type=script&lang=js"
export * from "./clientReject.vue?vue&type=script&lang=js"
import style0 from "./clientReject.vue?vue&type=style&index=0&id=15d66501&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d66501",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d66501')) {
      api.createRecord('15d66501', component.options)
    } else {
      api.reload('15d66501', component.options)
    }
    module.hot.accept("./clientReject.vue?vue&type=template&id=15d66501&scoped=true", function () {
      api.rerender('15d66501', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/clientReject/clientReject.vue"
export default component.exports